import { RefObject } from 'react';

export const getComputedColorValue = (bgRef: RefObject<HTMLDivElement>): string | null => {
  if (!bgRef.current) return null;
  const styles = getComputedStyle(bgRef.current!);
  const { backgroundColor, backgroundImage } = styles;
  if (backgroundColor === 'rgba(0, 0, 0, 0)' && backgroundImage === 'none') return null;
  return backgroundImage === 'none' ? backgroundColor : backgroundImage;
};
